import { ensureThemeJsonArray } from "../../functions/themeAssets";

export function parseDosDontFromTheme(themeData) {
  const dosRaw = ensureThemeJsonArray(themeData?.dos);
  const dontsRaw = ensureThemeJsonArray(themeData?.donts);

  const dos = dosRaw
    .map((item, i) => ({
      id: `do-${i}`,
      text: String(typeof item === "string" ? item : item?.text ?? item?.statement ?? "").trim(),
      type: "do",
    }))
    .filter((x) => x.text);

  const donts = dontsRaw
    .map((item, i) => ({
      id: `dont-${i}`,
      text: String(typeof item === "string" ? item : item?.text ?? item?.statement ?? "").trim(),
      type: "dont",
    }))
    .filter((x) => x.text);

  return { dos, donts, all: [...dos, ...donts] };
}

export function shuffleArray(arr) {
  const copy = [...arr];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
}
